import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicBreakpoint({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M8 5.5a2.5 2.5 0 110 5 2.5 2.5 0 010-5zM3.5 7.1c.28 0 .5.22.5.5v.8a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-.8c0-.28.22-.5.5-.5h3zm12 0c.28 0 .5.22.5.5v.8a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-.8c0-.28.22-.5.5-.5h3z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicBreakpoint.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicBreakpoint.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicBreakpoint svgRef={ref} {...props} />);
export default ForwardRef;
